function initUniversalCarousel(blockElement) {
    const container = blockElement.classList ? blockElement : document;
    
    // On cible le sélecteur universel js-carousel-wrapper
    const wrappers = container.querySelectorAll('.js-carousel-wrapper');

    wrappers.forEach(function(wrapper) {
        // On cible les éléments internes via leurs crochets JS
        const list = wrapper.querySelector('.js-carousel-list');
        const btnLeft = wrapper.querySelector('.js-carousel-prev');
        const btnRight = wrapper.querySelector('.js-carousel-next');

        if (!list || !btnLeft || !btnRight) return;

        const manageButtons = function() {
            if (window.innerWidth > 1200 && list.scrollWidth > list.clientWidth) {
                
                const maxScroll = list.scrollWidth - list.clientWidth;
                // La marge d'anticipation : les boutons disparaîtront 20px AVANT la butée
                const threshold = 20; 

                // Flèche de gauche (Précédent)
                if (list.scrollLeft > threshold) {
                    btnLeft.classList.add('is-visible');
                    btnLeft.disabled = false; // On rend le bouton cliquable
                } else {
                    btnLeft.classList.remove('is-visible');
                    btnLeft.disabled = true; // On désactive le bouton pour qu'il absorbe les clics accidentels
                }

                // Flèche de droite (Suivant)
                // On arrondit avec Math.ceil pour la précision
                if (Math.ceil(list.scrollLeft) < (maxScroll - threshold)) {
                    btnRight.classList.add('is-visible');
                    btnRight.disabled = false;
                } else {
                    btnRight.classList.remove('is-visible');
                    btnRight.disabled = true; 
                }

            } else {
                // Sur mobile ou si pas de débordement
                btnLeft.classList.remove('is-visible');
                btnRight.classList.remove('is-visible');
                btnLeft.disabled = true;
                btnRight.disabled = true;
            }
        };

        btnLeft.addEventListener('click', function(e) {
            e.preventDefault();
            const scrollAmount = list.clientWidth * 0.50; 
            list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        btnRight.addEventListener('click', function(e) {
            e.preventDefault();
            const scrollAmount = list.clientWidth * 0.50; 
            list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        list.addEventListener('scroll', manageButtons);
        window.addEventListener('resize', manageButtons);

        manageButtons();
    });
}

// Initialisation Front-end
document.addEventListener('DOMContentLoaded', function() {
    initUniversalCarousel(document);
});